<template>
  <path pid="0" d="M22 5.33H6a1 1 0 00-1 1v3a1 1 0 002 0v-2h6v14h-2a1 1 0 000 2h6a1 1 0 001-1v-.12a1 1 0 00-1-.88h-2v-14h6v2a1 1 0 102 0v-3a1 1 0 00-1-1z"/>
</template>
